import React from "react";

export const ChurchColorSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 497 497"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M288 29.776h-21.5a3 3 0 01-3-3V3a3 3 0 00-3-3h-24a3 3 0 00-3 3v23.776a3 3 0 01-3 3H209a3 3 0 00-3 3v24a3 3 0 003 3h21.5a3 3 0 013 3V127h30V62.776a3 3 0 013-3H288a3 3 0 003-3v-24a3 3 0 00-3-3z"
                fill="#ffbf54"
            />
            <path
                d="M248.5 14.776V3a3 3 0 013-3h-15a3 3 0 00-3 3v23.776a3 3 0 01-3 3h3c8.284 0 15-6.715 15-15zM248.5 112V59.776c0-8.284-6.716-15-15-15H222a1 1 0 01-1-1v-14h-12a3 3 0 00-3 3v24a3 3 0 003 3h21.5a3 3 0 013 3V127h30v-15z"
                fill="#ffa442"
            />
            <path
                d="M451 457h-95V296.181L451 342l10 15.1V447zM156.509 457H46V332l108.197-58.482z"
                fill="#ffe8c8"
            />
            <path
                d="M161 246.784L36 311.983V467l54.862 19.394 65.647-15.922L156 447H61a5 5 0 01-5-5v-92.301a5 5 0 012.688-4.433l102.115-52.592zM461 357.1v-45.117L346 252l-30.968 118.5L346 467l59.926 10L461 467v-20h-90a5 5 0 01-5-5V315.794c0-3.754 3.984-6.169 7.312-4.433z"
                fill="#fdd9b4"
            />
            <path
                d="M20.02 325.703v-8.35c0-1.118.621-2.143 1.613-2.66l4.387-17.504L131 242.432l10-.432v31.5L24.407 328.363c-1.997 1.042-4.387-.407-4.387-2.66z"
                fill="#8aaadc"
            />
            <path
                d="M131 242.432v22.43a5 5 0 01-2.688 4.433l-100.83 52.594a1 1 0 01-1.462-.887v-23.813l-14.387 7.504a3 3 0 00-1.613 2.66v38.35c0 2.253 2.39 3.702 4.387 2.66L151 277.115l10-19.654L151 232z"
                fill="#7398d4"
            />
            <path
                d="M486.98 328.784v-21.431a2.999 2.999 0 00-1.613-2.66L366 242.432l-12.671.387-2.298 28.851 127.915 65.617z"
                fill="#8aaadc"
            />
            <path
                d="M366 262.649v-20.214L346 232l-10 20 10 25.115 136.593 71.248c1.997 1.042 4.387-.407 4.387-2.66v-16.919l-118.293-61.703a4.999 4.999 0 01-2.687-4.432z"
                fill="#7398d4"
            />
            <path
                d="M336 457H161V182.58l78.374-40.92c5.729-2.653 12.523-2.653 18.253 0L336 182.58l10 34.325V447z"
                fill="#ffe8c8"
            />
            <path
                d="M246.218 168.076a4.997 4.997 0 014.563 0L346 216.906v-44.953l-88.374-45.32a20 20 0 00-18.252 0L151 171.953V467l97.5 10 97.5-10v-20H176a5 5 0 01-5-5V209.704a5 5 0 012.718-4.449z"
                fill="#fdd9b4"
            />
            <path
                d="M363.86 197.638l-113.079-59.562a4.997 4.997 0 00-4.563 0l-114.429 56.707c-1.996 1.024-4.369-.426-4.369-2.669v-23.209a3 3 0 011.631-2.669l16.333-11.402 93.99-48.201a20 20 0 0118.252 0l112.323 57.601a3 3 0 011.631 2.669v23.022l-3.351 5.043c0 2.244-2.373 3.694-4.369 2.67z"
                fill="#8aaadc"
            />
            <path
                d="M371.58 189.926l-116.235-59.51a14.997 14.997 0 00-13.689 0l-91.866 47.11c-1.996 1.024-4.369-.426-4.369-2.669v-19.953c0-.031.005-.062.006-.093l-18.375 9.424a3 3 0 00-1.631 2.669v38.209c0 2.244 2.373 3.693 4.369 2.669l116.429-59.707a4.997 4.997 0 014.563 0l116.43 59.707c1.996 1.024 4.369-.426 4.369-2.669v-15.187z"
                fill="#7398d4"
            />
            <path
                d="M282.349 343.626l-26.91-25.937c-1.937-1.867-4.438 7.2-6.94 7.2s-5.003-9.067-6.94-7.2l-13.141 12.666-7.345 12.039c-4.889 4.712-4.074 12.442-4.074 19.232V467h63l10-20v-85.374a24.994 24.994 0 00-7.65-18z"
                fill="#d77f4a"
            />
            <path
                d="M256 444V318.229l-.56-.54a10 10 0 00-13.879 0l-.56.54V444a3 3 0 01-3 3h-8a3 3 0 01-3-3V341.626c0-5.074 1.543-9.983 4.362-14.108l-16.712 16.108a25 25 0 00-7.651 18V467l34.074 10h14.852L290 467v-20h-31a3 3 0 01-3-3z"
                fill="#c86d36"
            />
            <path
                d="M492 490.309H11.606a5 5 0 01-5-5V472a5 5 0 015-5H492a5 5 0 015 5v13.309a5 5 0 01-5 5z"
                fill="#8aaadc"
            />
            <path
                d="M20 482a5 5 0 01-5-5v-10H5a5 5 0 00-5 5v20a5 5 0 005 5h487a5 5 0 005-5v-10z"
                fill="#7398d4"
            />
            <circle cx={248.5} cy={238.3} fill="#e9edf1" r={30} />
            <path
                d="M248.5 200.801c-20.678 0-37.5 16.822-37.5 37.5s16.822 37.5 37.5 37.5 37.5-16.822 37.5-37.5-16.822-37.5-37.5-37.5zm-22.5 37.5c0-9.777 6.271-18.114 15-21.21v42.42c-8.729-3.096-15-11.433-15-21.21zm30 21.21v-42.42c8.729 3.096 15 11.433 15 21.21s-6.271 18.114-15 21.21z"
                fill="#d77f4a"
            />
            <path
                d="M93.5 363c-9.665 0-17.5 7.835-17.5 17.5V428h35v-47.5c0-9.665-7.835-17.5-17.5-17.5zM403.5 363c-9.665 0-17.5 7.835-17.5 17.5V428h35v-47.5c0-9.665-7.835-17.5-17.5-17.5z"
                fill="#dce6eb"
            />
            <g fill="#c86d36">
                <path d="M121 420.5h-2.5v-40c0-13.785-11.215-25-25-25s-25 11.215-25 25v40H66c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h55c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5zm-37.5 0v-40c0-5.514 4.486-10 10-10s10 4.486 10 10v40zM431 420.5h-2.5v-40c0-13.785-11.215-25-25-25s-25 11.215-25 25v40H376c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h55c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zm-37.5 0v-40c0-5.514 4.486-10 10-10s10 4.486 10 10v40z" />
            </g>
        </svg>
    )
}